"use strict";

var _assertThisInitialized = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _classCallCheck = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/createClass");

var _inherits = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/inherits");

var _possibleConstructorReturn = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("invariant"));

var _getContext = _interopRequireDefault(require("./getContext"));

var _loseGL = _interopRequireDefault(require("./loseGL"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var __DEV__ = process.env.NODE_ENV === "development";
/**
 * WebGL context initial options.
 */


var propTypes = {
  onContextCreate: _propTypes.default.func.isRequired,
  onContextFailure: _propTypes.default.func.isRequired,
  onContextLost: _propTypes.default.func.isRequired,
  onContextRestored: _propTypes.default.func.isRequired,
  webglContextAttributes: _propTypes.default.object,
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  style: _propTypes.default.object,
  pixelRatio: _propTypes.default.number
};

var ErrorDebug = /*#__PURE__*/function (_react$Component) {
  _inherits(ErrorDebug, _react$Component);

  var _super = _createSuper(ErrorDebug);

  function ErrorDebug() {
    _classCallCheck(this, ErrorDebug);

    return _super.apply(this, arguments);
  }

  _createClass(ErrorDebug, [{
    key: "render",
    value: function render() {
      var error = this.props.error;
      var title = String(error.rawError || error.message || error);
      var detail = String(error.longMessage || error.rawError || "");
      var style = {
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        padding: "1em",
        background: "#a00",
        color: "#fff",
        fontSize: "12px",
        lineHeight: "1.2em",
        fontStyle: "normal",
        fontWeight: "normal",
        fontFamily: "monospace",
        overflow: "auto"
      };
      var titleStyle = {
        fontWeight: "bold",
        marginBottom: "1em"
      };
      var detailStyle = {
        whiteSpace: "pre"
      };
      return _react.default.createElement("div", {
        style: style
      }, _react.default.createElement("div", {
        style: titleStyle
      }, title), _react.default.createElement("div", {
        style: detailStyle
      }, detail));
    }
  }]);

  return ErrorDebug;
}(_react.Component);

var GLViewDOM = /*#__PURE__*/function (_react$Component2) {
  _inherits(GLViewDOM, _react$Component2);

  var _super2 = _createSuper(GLViewDOM);

  function GLViewDOM() {
    var _this;

    _classCallCheck(this, GLViewDOM);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: null
    });

    _defineProperty(_assertThisInitialized(_this), "webglContextAttributes", void 0);

    _defineProperty(_assertThisInitialized(_this), "canvas", void 0);

    _defineProperty(_assertThisInitialized(_this), "gl", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onContextLost", function (e) {
      e.preventDefault();
      _this.gl = null;

      _this.props.onContextLost();
    });

    _defineProperty(_assertThisInitialized(_this), "_onContextRestored", function () {
      _this.gl = _this._createContext();

      _this.props.onContextRestored(_this.gl);
    });

    _defineProperty(_assertThisInitialized(_this), "onRef", function (ref) {
      _this.canvas = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "debugError", !__DEV__ ? null : function (error) {
      _this.setState({
        error: error
      });
    });

    _defineProperty(_assertThisInitialized(_this), "afterDraw", !__DEV__ ? null : function () {
      if (_this.state.error) {
        _this.setState({
          error: null
        });
      }
    });

    return _this;
  }

  _createClass(GLViewDOM, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          onContextCreate = _this$props2.onContextCreate,
          onContextFailure = _this$props2.onContextFailure;

      var gl = this._createContext();

      if (gl) {
        this.gl = gl;
        onContextCreate(gl);
        var canvas = this.canvas;
        (0, _invariant.default)(canvas, "canvas is not settled in GLViewDOM#componentDidMount");
        canvas.addEventListener("webglcontextlost", this._onContextLost);
        canvas.addEventListener("webglcontextrestored", this._onContextRestored);
      } else {
        onContextFailure(new Error("no-webgl-context"));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.gl) {
        (0, _loseGL.default)(this.gl);
        this.gl = null;
      }

      var canvas = this.canvas;

      if (canvas) {
        canvas.removeEventListener("webglcontextlost", this._onContextLost);
        canvas.removeEventListener("webglcontextrestored", this._onContextRestored);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;

      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          pixelRatio = _this$props.pixelRatio,
          style = _this$props.style,
          debug = _this$props.debug,
          rest = _objectWithoutProperties(_this$props, ["width", "height", "pixelRatio", "style", "debug"]);

      if (!pixelRatio) pixelRatio = Number(typeof window === "object" && window.devicePixelRatio || 1);

      for (var k in propTypes) {
        if (rest.hasOwnProperty(k)) {
          delete rest[k];
        }
      }

      return _react.default.createElement("span", {
        style: _objectSpread({}, style, {
          display: "inline-block",
          position: "relative",
          width: width,
          height: height
        })
      }, _react.default.createElement("canvas", _extends({
        ref: this.onRef,
        style: {
          width: width,
          height: height
        },
        width: width * pixelRatio,
        height: height * pixelRatio
      }, rest)), error ? _react.default.createElement(ErrorDebug, {
        error: error
      }) : null);
    }
  }, {
    key: "_createContext",
    value: function _createContext() {
      var _this$props3 = this.props,
          webglContextAttributes = _this$props3.webglContextAttributes,
          debug = _this$props3.debug;
      var gl = (0, _getContext.default)(this.canvas, debug ? _objectSpread({}, webglContextAttributes, {
        preserveDrawingBuffer: true
      }) : webglContextAttributes);
      this.webglContextAttributes = webglContextAttributes || {};
      return gl;
    }
  }, {
    key: "captureAsDataURL",
    value: function captureAsDataURL() {
      var _this$canvas;

      if (!this.webglContextAttributes.preserveDrawingBuffer) {
        console.warn("Surface#captureAsDataURL is likely to not work if you don't define webglContextAttributes={{ preserveDrawingBuffer: true }}");
      }

      (0, _invariant.default)(this.canvas, "canvas is no longer available");
      return (_this$canvas = this.canvas).toDataURL.apply(_this$canvas, arguments);
    }
  }, {
    key: "captureAsBlob",
    value: function captureAsBlob() {
      var _this2 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (!this.webglContextAttributes.preserveDrawingBuffer) {
        console.warn("Surface#captureAsBlob is likely to not work if you don't define webglContextAttributes={{ preserveDrawingBuffer: true }}");
      }

      return Promise.resolve().then(function () {
        return new Promise(function (resolve, reject) {
          var _this2$canvas;

          return _this2.canvas ? (_this2$canvas = _this2.canvas).toBlob.apply(_this2$canvas, [resolve].concat(args)) : reject(new Error("canvas is no longer available"));
        });
      });
    }
  }]);

  return GLViewDOM;
}(_react.Component);

exports.default = GLViewDOM;

_defineProperty(GLViewDOM, "propTypes", propTypes);